export const ENTITY_USE_QUERY_GET_QUERY_INIT = 'ENTITY_USE_QUERY_GET_QUERY_INIT';
export const ENTITY_USE_QUERY_GET_QUERY_SUCCESS = 'ENTITY_USE_QUERY_GET_QUERY_SUCCESS';
export const ENTITY_USE_QUERY_GET_QUERY_FAILURE = 'ENTITY_USE_QUERY_GET_QUERY_FAILURE';

export const ENTITY_USE_QUERY_GET_DIMENSIONS_LIST_INIT = 'ENTITY_USE_QUERY_GET_DIMENSIONS_LIST_INIT';
export const ENTITY_USE_QUERY_GET_DIMENSIONS_LIST_SUCCESS = 'ENTITY_USE_QUERY_GET_DIMENSIONS_LIST_SUCCESS';
export const ENTITY_USE_QUERY_GET_DIMENSIONS_LIST_FAILURE = 'ENTITY_USE_QUERY_GET_DIMENSIONS_LIST_FAILURE';

export const ENTITY_USE_QUERY_GET_METRICS_LIST_INIT = 'ENTITY_USE_QUERY_GET_METRICS_LIST_INIT';
export const ENTITY_USE_QUERY_GET_METRICS_LIST_SUCCESS = 'ENTITY_USE_QUERY_GET_METRICS_LIST_SUCCESS';
export const ENTITY_USE_QUERY_GET_METRICS_LIST_FAILURE = 'ENTITY_USE_QUERY_GET_METRICS_LIST_FAILURE';

export const ENTITY_USE_QUERY_GET_POLYNOMIALS_LIST_INIT = 'ENTITY_USE_QUERY_GET_POLYNOMIALS_LIST_INIT';
export const ENTITY_USE_QUERY_GET_POLYNOMIALS_LIST_SUCCESS = 'ENTITY_USE_QUERY_GET_POLYNOMIALS_LIST_SUCCESS';
export const ENTITY_USE_QUERY_GET_POLYNOMIALS_LIST_FAILURE = 'ENTITY_USE_QUERY_GET_POLYNOMIALS_LIST_FAILURE';

export const ENTITY_USE_QUERY_RESET = 'ENTITY_USE_QUERY_RESET';


// WEBPACK FOOTER //
// ./source/client/actions/entityUseQuery/types.js